import CountyForm from "./CountyForm";
import {useState} from "react";

const CreateCounty = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Counties", url: "/counties"},
        {content: "Add County", url: "/counties/create"},
    ]);

    return (
        <>
            <CountyForm crumbs={crumbs} title={"Add County"} btnText={"Add"}/>
        </>
    )
}
export default CreateCounty;